import React from 'react';
import { useNavigate } from 'react-router-dom';
import cloutCertifiedStar from '../../assets/images/clout-certified-star.png';

const CertificationSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="relative w-full min-h-[600px] md:min-h-[700px] lg:min-h-[800px] bg-white py-12 md:py-16 lg:py-20"
      data-name="certification"
      id="node-12_9959"
    >
      <div className="relative max-w-[1440px] mx-auto h-full px-6 md:px-8 lg:px-12 xl:px-16">
        {/* Mobile Layout - Stacked */}
        <div className="md:hidden flex flex-col items-center text-center space-y-8 py-8">
          <div className="flex flex-col gap-6 max-w-md">
            <h2 className="font-['Ovo',_serif] text-[28px] sm:text-[32px] text-[#1f1f1f] uppercase leading-tight">
              Become CLOUT Certified
            </h2>
            <p className="font-['Ovo',_serif] text-[16px] text-[#1f1f1f] leading-relaxed">
              Join a trusted network of verified providers. By verifying your information and adding
              additional credentials, you become CLOUT Certified. Increase your CLOUT and
              credibility in the Aesthetic Industry.
            </p>
            <button
              className="inline-flex items-center justify-center px-6 py-3 min-h-[48px] border-2 border-[#1f1f1f] hover:bg-[#1f1f1f] transition-all duration-200 cursor-pointer group w-full"
              onClick={() => navigate('/wizard')}
            >
              <span className="font-['Ovo',_serif] text-[16px] text-[#1f1f1f] uppercase group-hover:text-white transition-colors">
                Get CLOUT Certified
              </span>
            </button>
          </div>
          <div className="w-[400px] h-[400px] sm:w-[450px] sm:h-[450px]">
            <img
              src={cloutCertifiedStar}
              alt="CLOUT Certified Star"
              className="w-full h-full object-contain"
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>

        {/* Desktop Layout - Side by side */}
        <div className="hidden md:flex items-center justify-between h-full gap-12 lg:gap-16 xl:gap-20">
          {/* Left side - Text content */}
          <div className="flex-1 max-w-[500px] lg:max-w-[550px]">
            <div className="flex flex-col gap-6 lg:gap-8">
              <h2 className="font-['Ovo',_serif] text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] text-[#1f1f1f] uppercase leading-tight">
                Become CLOUT Certified
              </h2>
              <p className="font-['Ovo',_serif] text-[18px] md:text-[20px] lg:text-[22px] text-[#1f1f1f] leading-relaxed">
                Join a trusted network of verified providers. By verifying your information and
                adding additional credentials, you become CLOUT Certified. Increase your CLOUT and
                credibility in the Aesthetic Industry.
              </p>
              <button
                className="inline-flex items-center justify-center px-8 py-4 min-h-[52px] border-2 border-[#1f1f1f] hover:bg-[#1f1f1f] transition-all duration-200 cursor-pointer group self-start"
                onClick={() => navigate('/wizard')}
              >
                <span className="font-['Ovo',_serif] text-[16px] md:text-[18px] text-[#1f1f1f] uppercase group-hover:text-white transition-colors">
                  Get CLOUT Certified
                </span>
              </button>
            </div>
          </div>

          {/* Right side - Large star */}
          <div className="flex-shrink-0 w-[600px] h-[600px] lg:w-[750px] lg:h-[750px] xl:w-[850px] xl:h-[850px]">
            <img
              src={cloutCertifiedStar}
              alt="CLOUT Certified Star - Professional Healthcare Certification"
              className="w-full h-full object-contain"
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificationSection;
